/* eslint-disable no-undefined */
'use es6';

import { Component as ReactComponent } from 'react';
import PropTypes from 'prop-types';
import identity from 'transmute/identity';
import debounce from 'transmute/debounce';
import SearchDebounceDelay from 'SalesContentIndexUI/data/constants/SearchDebounceDelay';
import connect from 'SalesContentIndexUI/data/redux/connect';
import SearchActions from 'SalesContentIndexUI/data/actions/SearchActions';
import * as FilterTypes from 'SalesContentIndexUI/data/lib/FilterTypes';
import { getLocationQuery } from 'SalesContentIndexUI/data/utils/router';
import { stringify } from 'hub-http/helpers/params';
import { jsx as _jsx } from "react/jsx-runtime";
export default (Component => {
  class RouteChangeHandler extends ReactComponent {
    constructor(props) {
      super(props);
      this.handleHistoryUpdated = (location, action) => {
        if (action !== 'POP') {
          return;
        }
        this.props.searchFromQueryParams({
          queryParams: getLocationQuery(location)
        });
      };
      this.setQueryParam = query => {
        this.props.history.push({
          pathname: this.props.location.pathname,
          search: stringify(query)
        });
      };
      this.updateRoute = updatedQuery => {
        const {
          pathname
        } = this.props.location;
        const query = getLocationQuery(this.props.location);
        this.props.history.push({
          pathname,
          search: stringify(Object.assign({}, query, updatedQuery))
        });
      };
      this.getPage = page => {
        this.updateRoute({
          page: page + 1
        });
        this.props.getPage(page);
      };
      this.setSort = ({
        selectedSort,
        resetSearch
      }) => {
        this.updateRoute(Object.assign({}, selectedSort.toJS(), {
          page: 1
        }));
        this.props.setSort({
          selectedSort,
          resetSearch
        });
      };
      this.setSelectedFolder = folderSearchResult => {
        this.updateRoute({
          folder: folderSearchResult && folderSearchResult.contentId,
          page: 1,
          q: undefined
        });
        this.props.setSelectedFolder(folderSearchResult);
      };
      this.setViewFilter = (selectedViewFilter, id) => {
        const queryParams = {
          view: selectedViewFilter.id,
          page: 1
        };
        if (selectedViewFilter.type !== FilterTypes.CUSTOM) {
          queryParams.type = selectedViewFilter.type;
        }
        this.setQueryParam(queryParams);
        this.props.setViewFilter(selectedViewFilter, id);
      };
      this.setSearchQuery = query => {
        this.debouncedUpdateRoute({
          q: query,
          page: 1,
          folder: undefined,
          field: undefined,
          order: undefined
        });
        this.props.setSearchQuery(query);
      };
      this.debouncedUpdateRoute = debounce(SearchDebounceDelay, this.updateRoute);
    }
    componentDidMount() {
      this.unlisten = this.props.history.listen(this.handleHistoryUpdated);
    }
    componentWillUnmount() {
      this.unlisten();
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        getPage: this.getPage,
        setSort: this.setSort,
        setSelectedFolder: this.setSelectedFolder,
        setViewFilter: this.setViewFilter,
        setSearchQuery: this.setSearchQuery
      }));
    }
  }
  RouteChangeHandler.propTypes = {
    searchFromQueryParams: PropTypes.func.isRequired,
    getPage: PropTypes.func.isRequired,
    setSearchQuery: PropTypes.func.isRequired,
    setSort: PropTypes.func.isRequired,
    setSelectedFolder: PropTypes.func.isRequired,
    setViewFilter: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  };
  return connect(identity, SearchActions.get())(RouteChangeHandler);
});